import React from 'react';
import { Helmet } from 'react-helmet-async';
import { StaffAllScannedItemsView } from '@/components/staff/StaffAllScannedItemsView';

export const StaffAllScannedItems = () => {
  return (
    <>
      <Helmet>
        <title>All Scanned Items | Staff Portal</title>
        <meta name="description" content="View all scanned products across all orders. Search, filter, and export scanned inventory data." />
      </Helmet>
      <StaffAllScannedItemsView />
    </>
  );
};